module.exports = __webpack_public_path__ + "img/image-space-capsule-landscape.3c5e7125.jpg";